import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PhoneNumbersService } from '../phone-numbers.service';
import { Msisdn } from '../../shared/msisdn/msisdns';
import { AccountSettingsService } from '../../my-account/account-settings.service';
import { PlanWithLimits } from '../../shared/models/plans';

@Component({
  selector: 'cc-phone-number-settings',
  templateUrl: './phone-number-settings.component.html',
  styleUrls: ['./phone-number-settings.component.scss']
})
export class PhoneNumberSettingsComponent implements OnInit {
  public number;
  public msisdn;
  public plan: PlanWithLimits;
  public hasAutoAppliedEeaMsisdn = false;

  constructor(
    private phoneNumbersService: PhoneNumbersService,
    private route: ActivatedRoute,
    private accountSettingsService: AccountSettingsService
  ) {}

  ngOnInit() {
    this.getNewNumber();
  }

  getNewNumber() {
    const phoneNumberId = Number(this.route.snapshot.paramMap.get('id'));
    this.phoneNumbersService.getNumberSettings(phoneNumberId).subscribe(number => (this.number = number));
    this.phoneNumbersService.getPhoneNumbers().subscribe(phoneNumbers => {
      this.hasAutoAppliedEeaMsisdn = this.checkIfHasAutoAppliedInitialMsisdn(phoneNumbers);
      this.msisdn = phoneNumbers.find(phoneNumber => phoneNumber.id === phoneNumberId);
    });
    this.accountSettingsService.currentPlan().subscribe(plan => {
      this.plan = plan;
    });
  }

  private checkIfHasAutoAppliedInitialMsisdn(phoneNumbers: Msisdn[]): boolean {
    const initialMsisdns = phoneNumbers.filter(msisdn => msisdn.initial);
    const numberOfInitialMsisdns = initialMsisdns.length;
    if (numberOfInitialMsisdns <= 1) {
      return false;
    }
    const numberOfInitialEeaMsisdns = initialMsisdns.filter(msisdn => msisdn.eea).length;
    return numberOfInitialEeaMsisdns < numberOfInitialMsisdns;
  }
}
